import { render, staticRenderFns } from "./StudentRecords.vue?vue&type=template&id=8560a8b8&scoped=true"
import script from "./StudentRecords.vue?vue&type=script&lang=js"
export * from "./StudentRecords.vue?vue&type=script&lang=js"
import style0 from "./StudentRecords.vue?vue&type=style&index=0&id=8560a8b8&prod&scoped=true&lang=css"
import style1 from "./StudentRecords.vue?vue&type=style&index=1&id=8560a8b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8560a8b8",
  null
  
)

export default component.exports